<template>
  <v-dialog v-model="viewDialog" persistent max-width="600">
    <v-card :loading="loading" loader-height="2">
      <v-card-title>View template</v-card-title>
      <v-card-text>
        <div class="mylist">
          <ul>
            <li>
              <div class="myleft">name</div>
              <div class="myright">{{ view.subscriber_typesid }}</div>
              <div class="clearall"></div>
            </li>
            <li>
              <div class="myleft">template_type</div>
              <div class="myright">{{ view.template_type }}</div>
              <div class="clearall"></div>
            </li>
            <li>
              <div class="myleft">active</div>
              <div class="myright">{{ view.active ? "Yes" : "No" }}</div>
              <div class="clearall"></div>
            </li>

            <li>
              <div class="myleft">updated</div>
              <div class="myright">{{ view.updated | myDating }}</div>
              <div class="clearall"></div>
            </li>
          </ul>

          <div v-html="view.message">
          </div>
        </div>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn small text color="red" v-on="on" @click="closeDialog">
              close
            </v-btn>
          </template>
          <span>cancel</span>
        </v-tooltip>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import Restful from "@/services/RestFul";
//   import moment from "moment";
//   import Utils from "./../../../../mixins/utils";
export default {
  props: {
    viewDialog: Boolean,
    myId: {type: Number, default: 0},
  },
  // mixins: [Utils],
  data() {
    return {
      loading: false,
      responseMessage: null,
      view: {
        active: false,
        updated: null,
        subscriber_typesid: null,
        subscriber_types: null,
        template_type: null,
        message: null,
      },
    };
  },
  created() {
    this.find();
  },
  methods: {
    find() {
      Restful.templates.mails
          .find(this.myId)
          .then((response) => {
            console.log('template stemplates', response);
            this.view.subscriber_types = response.data.subscriber_types;
            this.view.template_type = response.data.template_type;
            this.view.message = response.data.message;
            this.view.active = response.data.active;
            this.view.updated = response.data.updated;
          })
          .catch((error) => {
            console.log(error.response);
            self.loading = false;
          });
    },
    closeDialog() {
      let payload = {id: this.myId, state: false};
      this.$emit("closeView", payload);
    },
  },
};
</script>
